import { z } from 'zod';

/**
 * ISO/ASTM 52900 process categories.
 *
 * Both powder-bed-fusion entries collapse to the single ASTM label
 * 'Powder Bed Fusion' when matched against Senvol data — that split exists only
 * in our category list, not in the standard.
 *
 * `@accio3d/server-shared/messaging` holds a second copy, because that package
 * still compiles with `rootDir: src` and so cannot import this source. The two
 * are pinned equal by a spec; when server-shared gains the same build treatment
 * as the API, delete its copy and re-export from here.
 */
export const PROCESS_CATEGORIES = [
  'material_extrusion',
  'vat_photopolymerization',
  'powder_bed_fusion_polymer',
  'powder_bed_fusion_metal',
  'material_jetting',
  'binder_jetting',
] as const;

export type ProcessCategory = (typeof PROCESS_CATEGORIES)[number];

export const processCategorySchema = z.enum(PROCESS_CATEGORIES);
